export function useAdminAuth(config) {
  const headerName = config.auth.headerName;
  const storageKey = config.auth.tokenStorageKey;

  function getToken() {
    return localStorage.getItem(storageKey) || "";
  }
  function setToken(token) {
    localStorage.setItem(storageKey, token || "");
  }
  function clearToken() {
    localStorage.removeItem(storageKey);
  }
  function buildAuthHeaders(token) {
    return { [headerName]: token };
  }

  return { getToken, setToken, clearToken, buildAuthHeaders };
}
